// extracted by mini-css-extract-plugin
export var component = "MunicipalitySelector-module--component--n80YC";
export var label = "MunicipalitySelector-module--label--QgKs4";